import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import { hotComics, latestUpdates } from '@/mocks/comics';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫网 - 首页',
    description: '韩漫网提供韩漫漫画免费阅读服务，无删减韩漫下拉式免费在线阅读。环境纯净无弹窗广告，海量韩漫资源每日更新。',
    url: 'https://www.hanmanwang.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'https://www.hanmanwang.com/',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-end justify-between mb-6">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                    漫画分类
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">选择你喜欢的漫画类型</p>
                </div>
              </div>
              <CategoryNav />
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-end justify-between mb-6">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                    热门推荐
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">最受读者欢迎的韩漫作品</p>
                </div>
                <a
                  href="/category/all"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
                >
                  查看全部
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </a>
              </div>
              <HotComics comics={hotComics} />
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-end justify-between mb-6">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                    最新更新
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">每日更新的韩漫漫画资源</p>
                </div>
                <a
                  href="/category/all"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
                >
                  查看全部
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </a>
              </div>
              <LatestUpdates comics={latestUpdates} />
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto text-center">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                为什么选择韩漫网？
              </h2>
              <p className="text-sm text-foreground-500 mb-10 max-w-xl mx-auto">
                我们致力于为韩漫爱好者提供最佳的在线阅读体验
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-shield-check-line', title: '无删减内容', desc: '完整呈现原作内容，拒绝删减' },
                  { icon: 'ri-close-circle-line', title: '无弹窗广告', desc: '纯净阅读环境，不打扰阅读' },
                  { icon: 'ri-refresh-line', title: '每日更新', desc: '海量韩漫资源每日更新上架' },
                  { icon: 'ri-device-line', title: '下拉式阅读', desc: '流畅的下拉式阅读体验' },
                ].map((item) => (
                  <div key={item.title} className="p-6 rounded-lg bg-background-50 border border-background-200/60">
                    <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className={`${item.icon} text-xl text-primary-500`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}